<template>
  <!-- <batch>
    <template #pre="{structure}">
      <span class="headline">this is :<strong>{{structure}}</strong></span>
    </template>
  </batch>-->
  <v-container fluid ma-0 pa-0>
    <batch-view :args="args" :headers.sync="headers">
      <template #area_query>
        <v-layout row wrap>
          <gh-date-picker v-model="args.date"></gh-date-picker>
          <v-text-field v-model="args.structure_id" name="name" label="label" id="id"></v-text-field>
        </v-layout>
      </template>
      <template #table-cell-O-Actions="{props}">
        <v-btn color="success">分派</v-btn>
      </template>
    </batch-view>
  </v-container>
</template>

<style scoped>
</style>

<script>
import Workorder from "./workorder.ts";
export default Workorder;
</script>